import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 51rem;

  @media (max-width: 768px) {
    width: 100%;
  }

  > .MuiFormControl-root {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;

export const ContainerClear = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 1.2rem;

  > div:nth-child(1) {
    margin-right: 1rem;
  }
`;

export const ContainerLinha = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  > div:nth-child(1) {
    margin-right: 1rem;
  }

  flex-wrap: wrap;

  /* Media query para telas menores (exemplo: 768px ou menos) */
  @media (max-width: 768px) {
    flex-direction: column; /* Torna os itens empilhados verticalmente */
  }

  @media (max-width: 768px) {
    div:nth-child(1) {
      margin-right: 0;
    }
  }
`;

export const ContainerLinhaCampo = styled.div`
  flex: 1; /* Faz com que cada campo tenha o mesmo tamanho */
  margin: 0px;
  padding: 0px;
  text-align: center;

  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  /* Ajuste do tamanho para quando estiver empilhado */
  @media (max-width: 768px) {
    width: 100%; /* Faz com que cada campo ocupe a largura total em telas menores */
  }
`;
